import {Injector} from '@angular/core';
export let InjectorInstance: Injector;
export function setAppInjector(injector: Injector) {
  if (InjectorInstance) {
      return;
  } else {
    InjectorInstance = injector;
  }
}
